import React, { useRef } from 'react';
import { Button, SplitButton } from '@progress/kendo-react-buttons';
import { ITicketProps } from '../../../../../../types/Ticket/ITicket';
import { TreeView, TreeViewExpandChangeEvent, TreeViewItemClickEvent } from '@progress/kendo-react-treeview';
import { Popup, PopupHandle } from '@progress/kendo-react-popup';
import { TicketApi } from '../../../../../../redux/api/TicketApi';
import { expandedState, processTreeData } from '../../../../../../utils/TreeDataOperations';
import { WorkflowApi } from '../../../../../../redux/api/WorkflowApi';
import _ from 'lodash';
import { PartialSpinny } from '../../../../../Nav/Spinny';

const WorkflowButton: React.FC<ITicketProps> = (ticket) => {
    const selectField = "selected";
    const expandField = "expanded";
    const dataItemKey = "Id";
    const subItemsField = "Templates";
    const fields = { selectField, expandField, dataItemKey, subItemsField };
    const [show, setShow] = React.useState(false);
    const parent = useRef(null);
    const popupRef = useRef<PopupHandle>(null);

    const { data: template } = TicketApi.useGetTemplateQuery(ticket.Template_Id, { skip: !ticket.Template_Id });
    const { data: templates, isLoading } = TicketApi.useGetMyTemplatesQuery();
    const { data: userProfile } = TicketApi.useGetUserProfileQuery();
    const [applyWorkflow, { isLoading: applyingTemplate }] = WorkflowApi.useApplyWorkflowMutation();

    const selectedTemplate = { Id: ticket.Template_Id, Name: ticket.Template_Id ? template?.Call_Template_Name : null } //templates?.map(t => t.Templates.filter(t2=>t2.Id === props.templateId)
    const [value, setValue] = React.useState(null);
    const [expanded, setExpanded] = React.useState([templates?.length && templates?.[0][dataItemKey]]);

    React.useEffect(() => {
        (selectedTemplate && !value) && setValue(selectedTemplate);
    }, [template, selectedTemplate]);


    //A listener to close the popu if the user clicks outside of it
    React.useEffect(() => {
        const listener = (e) => {
            // console.log('listener', e.target)
            if (!popupRef?.current.element?.contains(e.target)) {
                setShow(false);
            }
        }
        document.addEventListener('mousedown', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
        }
    }, [popupRef]);

    const treeData = React.useMemo(
        () => {
            const fields = { selectField, expandField, dataItemKey, subItemsField };
            //console.log('processTreeData', selectedTemplate, value)
            let tree = processTreeData(templates || [], { expanded, value }, fields)
            //console.log('processTreeData2', tree)
            return tree
        }, [expanded, value, templates]
    );

    const onChange = (event: TreeViewItemClickEvent) => {
        console.log('event', event.item, expanded, expanded.includes(event?.item.value?.Id))
        if (event?.item && event?.item.Id < 0) {
            if (!expanded.includes(event?.item.Id))
                setExpanded([event?.item.Id]); //expand
            else
                //let newArray = [...expanded].splice(expanded.indexOf(event?.value.Id)
                setExpanded((oldVal) => {
                    let newVal = [...oldVal]
                    newVal.splice(expanded.indexOf(event?.item.Id), 1)
                    return newVal;
                }); //collaps
            setShow(true); //stay open

            return
        }

        if ((event.item.Id && !ticket.Template_Id) || (ticket.Template_Id && window.confirm(`Changing the Template / Workflow will REPLACE the ${userProfile.Phrases.CallPhrase} ${userProfile.Phrases.Description} and remove any incomplete workflow actions. Are you sure you want to continue?`))) {
            setValue(event.item);
            //props.onChange(event)
            applyWorkflow({ id: event.item.Id, ticketId: ticket.ID }).unwrap().then(() => {
                setShow(undefined);
            });
        } else {
            setShow(undefined); //Close
        }
    }
    const onExpandChange = React.useCallback(
        (event: TreeViewExpandChangeEvent) =>
            setExpanded(expandedState(event.item, dataItemKey, expanded)),
        [expanded]
    );

    if (treeData?.length === 0) return null;

    return (
        <div ref={parent}>
            {/* selectedTemplate:{selectedTemplate?.Name} - value:{value?.Name} */}
            <Button title={selectedTemplate?.Name || 'Apply template / workflow'} disabled={ticket.Is_Loading} className={`${selectedTemplate?.Id && 'on'}`} size='large' imageUrl='./images/Toolbar/workflow.png' onClick={() => setShow((s) => !s)} ></Button>
            <Popup ref={popupRef} anchor={parent?.current} popupClass='quick-notes-popup' show={show}>
                {applyingTemplate && <PartialSpinny />}
                <h6 className='ms-2'>Templates / Workflows</h6>
                <TreeView className='' expandIcons={true} data={treeData} textField='Name' childrenField={subItemsField} onExpandChange={onExpandChange} onItemClick={onChange}
                    key={dataItemKey}
                    selectField={selectField}
                    expandField={expandField}

                />
            </Popup></div>
    );
};

export default WorkflowButton;